import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { mergeClassNames } from 'shared/utils/mergeClassNames';
import { YearKeyValuePair } from './utils';

interface YearButtonProps {
  value: YearKeyValuePair;
  radius?: 'left' | 'right';
  selected: boolean;
  disabled?: boolean;
  className?: string;
  onClick: (value: YearKeyValuePair) => unknown;
}

const StyledButton = styled.button`
  &.left-radius {
    border-radius: 4px 0px 0px 4px;
  }
  &.right-radius {
    border-radius: 0px 4px 4px 0px;
  }
  &.selected {
    color: ${COLORS.whiteBase};
    background-color: ${COLORS.ctaPrimary};
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
`;

const YearButton: React.FC<YearButtonProps> = ({
  value,
  radius,
  selected,
  disabled,
  className,
  onClick,
}) => {
  return (
    <StyledButton
      disabled={disabled}
      onClick={() => onClick(value)}
      className={mergeClassNames(
        'year',
        className,
        selected && 'selected',
        disabled && 'disabled',
        radius && (radius === 'left' ? 'left-radius' : 'right-radius'),
      )}
    >
      {value.text}
    </StyledButton>
  );
};

export default YearButton;
